import React from 'react'
import { useTranslation } from 'react-i18next'

import {useAuthStore} from '@/stores'
import {BackButton} from '@/components'

import styles from './styles.scss'

export const BackToLoginLink = () => {
    const { t } = useTranslation()
    const {backToLogin} = useAuthStore()

    return (
        <BackButton
            className={styles.backToLogin}
            onClick={backToLogin}
            title={t('BackToLoginLink.back')}
        />
    )
}
